import * as tslib_1 from "tslib";
import * as React from "react";
import RouteStatus from "../components/Global/RouteStatus";
var NotFound = /** @class */ (function (_super) {
    tslib_1.__extends(NotFound, _super);
    function NotFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFound.prototype.render = function () {
        return (React.createElement(RouteStatus, { code: 404 },
            React.createElement("div", { className: "error-page" },
                React.createElement("h2", { className: "headline text-yellow" }, " 404"),
                React.createElement("div", { className: "error-content" },
                    React.createElement("h3", null,
                        React.createElement("i", { className: "fa fa-warning text-yellow" }),
                        " Oops! Page not found.")))));
    };
    return NotFound;
}(React.Component));
export default NotFound;



//////////////////
// WEBPACK FOOTER
// ./src/views/NotFound.tsx
// module id = 536
// module chunks = 0